const e={styleOverrides:{root:{backgroundImage:"none"},rounded:{borderRadius:3}},defaultProps:{elevation:0}};export{e as default};
